import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConciliacionService } from "../../core/conciliacion/conciliacion.service";
import { MessageService } from "primeng/components/common/messageservice";

declare var $: any;
declare var moment;

@Component({
  selector: 'app-conciliacion',
  templateUrl: './conciliacion.component.html',
  styleUrls: ['./conciliacion.component.scss']
})
export class ConciliacionComponent implements OnInit, AfterViewInit {

  reportStartDate: string;
  reportEndDate: string;
  isDownloadingReport = false;

  constructor(private conciliacionService: ConciliacionService,
              private messageService: MessageService) {
  }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    const inputDate = $('#transaction-report-date-input');
    inputDate.daterangepicker({
      autoUpdateInput: false,
      maxSpan: {days: 31},
      ranges: {
        'HOY': [moment(), moment()],
        'AYER': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'ULTIMOS 7 Days': [moment().subtract(6, 'days'), moment()],
        'ULTIMOS 30 Days': [moment().subtract(29, 'days'), moment()]
      },
      locale: {customRangeLabel: 'PERSONALIZADO'}
    });

    inputDate.on('apply.daterangepicker', (ev, picker) => {
      this.reportStartDate = picker.startDate.format('YYYY-MM-DD');
      this.reportEndDate = picker.endDate.format('YYYY-MM-DD');
      inputDate.val(picker.startDate.format('DD-MM-YYYY') + ' - ' + picker.endDate.format('DD-MM-YYYY'));
    });

    inputDate.on('cancel.daterangepicker', (ev, picker) => {
      this.reportStartDate = undefined;
      this.reportEndDate = undefined;
      inputDate.val('');
    });
  }

  downloadTransactionReport() {
    if (!this.reportStartDate || !this.reportEndDate) {
      return;
    }
    this.isDownloadingReport = true;
    this.conciliacionService.downloadTransactionReport(this.reportStartDate, this.reportEndDate).subscribe(
      (blob) => {
        this.isDownloadingReport = false;
        this.downloadFile(blob, `transactions-${this.reportStartDate}-to-${this.reportEndDate}.zip`);
      },
      (error) => {
        this.isDownloadingReport = false;
        this.messageService.add({
          severity: 'error',
          summary: '',
          detail: 'Error al generar el reporte de transacciones.'
        });
      }
    );
  }

  private downloadFile(blob: Blob, filename: string) {
    const url = window.URL.createObjectURL(blob);
    const anchorElem = document.createElement('a');
    anchorElem.style.display = 'none';
    anchorElem.href = url;
    anchorElem.download = filename;

    document.body.appendChild(anchorElem);
    anchorElem.click();
    document.body.removeChild(anchorElem);

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 1000);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/conciliacion/conciliacion.component.ts